module.exports = __webpack_public_path__ + "img/gs90-1.dc7d4d5f.png";